import React, { useEffect, useState } from 'react';
import Tree, { TreeProps } from "antd/es/tree";
import { useSelector } from 'react-redux';
import { clearPermissionTree, clearStoreChat, fetchDataAnswer, fetchMessageWelcome, fetchPermissionTree, getDataMessageWelcome, getPermissionTree } from 'features/private-chat/store/slice';
import { FilePdfOutlined, InfoCircleOutlined, LinkOutlined } from '@ant-design/icons';
import Title from 'antd/es/typography/Title';
import ChatForm from "views/components/ChatView/ChatForm";
import ChatView from "views/components/ChatView/ChatView";
import { useDispatch } from 'react-redux';
import { Popover, Layout } from 'antd';
import { marked } from "marked";
import styles from '../styles.module.scss'

const { Footer, Content } = Layout;
const { DirectoryTree } = Tree;

interface tabLogNameProps {
    dataLogName?: string[]
}

const ChatBox: React.FC<tabLogNameProps> = ({dataLogName}) => {

    const dispatch = useDispatch();

    const [renderDone, setRenderDone] = useState<boolean>(false);

    const handleRenderDone = (status: boolean) => {
        if (status) {
            setRenderDone(status);
        } else {
            setRenderDone(false);
        }
    };

    const handleSubmit = (data: any) => {
        dispatch(
            fetchDataAnswer({
                answer: data.answer,
                checked: data.checked,
                chat_page: "securityLog",
                check_documents: handleGetDocumentName(),
                check_log_names: dataLogName || []
            })
        );
    };

    const permissionTreeData = useSelector(getPermissionTree);
    const messageWelcome = useSelector(getDataMessageWelcome);
    //tree
    const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([]);
    const [checkedKeys, setCheckedKeys] = useState<React.Key[]>([]);
    const [selectedKeys, setSelectedKeys] = useState<React.Key[]>([]);
    const [autoExpandParent, setAutoExpandParent] = useState<boolean>(true);


    useEffect(() => {
        dispatch(fetchMessageWelcome({ chat_page: "securityLog" }));
        dispatch(fetchPermissionTree({ chat_page: "securityLog" }));
        const element = document.getElementById("introduce")?.offsetHeight;
        setScrollY(element ?? 0);
        const handleResize = () => {
            const element = document.getElementById("introduce")?.offsetHeight;
            setScrollY(element ?? 0);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
            dispatch(clearStoreChat());
            dispatch(clearPermissionTree());
        };
    }, []);


    const onSelect: TreeProps["onSelect"] = (selectedKeysValue: any) => {
        setSelectedKeys(selectedKeysValue);
    };

    const onCheck: TreeProps["onCheck"] = (checkedKeysValue: any) => {
        setCheckedKeys(checkedKeysValue as React.Key[]);
    };

    const [scrollY, setScrollY] = useState<number>(
        document.getElementById("introduce")?.offsetHeight ?? 0
    );

    const onExpand: TreeProps["onExpand"] = (expandedKeysValue: any) => {
        setExpandedKeys(expandedKeysValue);
        setAutoExpandParent(false);
    };

    const renderTreeNodes = (data: any) =>
        data.map((item: any) => {
            if (item.children) {
                return (
                    <Tree.TreeNode
                        title={<span dangerouslySetInnerHTML={{ __html: item.title }} />}
                        key={item.key}
                        disabled={item.disabled}
                    >
                        {renderTreeNodes(item.children)}
                    </Tree.TreeNode>
                );
            }
            return (
                <Tree.TreeNode
                    title={<span dangerouslySetInnerHTML={{ __html: item.title }} />}
                    key={item.key}
                    icon={item?.type === "url" ? <LinkOutlined /> : <FilePdfOutlined />}
                    selectable={false}
                    disabled={item.disabled}
                />
            );
        });

    const handleGetDocumentName = () => {
        let result: any = [];
        function recurse(items: any, isChild = false) {
            for (const item of items) {
                if (item.children && item.children.length > 0) {
                    recurse(item.children, true);
                } else if (isChild && checkedKeys.includes(item.key)) {
                    result.push(item.name);
                }
            }
        }
        recurse(permissionTreeData);
        return result;
    };

    return (
        <div className={styles.layout_style}>
            <div className={styles.left_content}>
                <div
                    style={{
                        padding: "12px 0px 12px 12px",
                        height: `calc(100% - ${scrollY}px)`,
                    }}
                >
                    <span
                        style={{
                            fontSize: "1rem",
                            lineHeight: "1.125rem",
                            fontWeight: 500,
                        }}
                    >
                        Document Tree
                    </span>
                    <DirectoryTree
                        style={{ height: "100%", overflow: "scroll" }}
                        checkable
                        onExpand={onExpand}
                        expandedKeys={expandedKeys}
                        autoExpandParent={autoExpandParent}
                        onCheck={onCheck}
                        checkedKeys={checkedKeys}
                        onSelect={onSelect}
                        selectedKeys={selectedKeys}
                    >
                        {renderTreeNodes(permissionTreeData)}
                    </DirectoryTree>
                </div>
            </div>

            <div className={styles.right_content}>
                <header className={styles.page_header}>
                    <div className={styles.content_header}>
                        <Title level={2} className={styles.title}>
                            AI monitoring Copilot{" "}
                            <Popover
                                trigger="click"
                                placement="rightTop"
                                content={
                                    <div
                                        style={{
                                            width: "450px",
                                            height: "100%",
                                            maxHeight: "450px",
                                            overflowY: "scroll",
                                        }}
                                    >
                                        {messageWelcome.message.map((message: any, idx: number) => {
                                            return (
                                                <div
                                                    key={idx}
                                                    className={styles.text}
                                                    dangerouslySetInnerHTML={{
                                                        __html: marked.parse(message.answer || ""),
                                                    }}
                                                />
                                            );
                                        })}
                                    </div>
                                }
                            >
                                <InfoCircleOutlined style={{ marginLeft: "8px" }} />
                            </Popover>
                        </Title>
                    </div>
                </header>
                <div className={styles.chat_screen}>
                    {/* <div className={styles.header_chat_screen}>Bot chat</div> */}
                    <Content className={styles.content_style}>
                        <ChatView onDone={(status: boolean) => handleRenderDone(status)} />
                    </Content>
                    <Footer className={styles.footer_style}>
                        <ChatForm
                            handleSubmit={(data: any) => handleSubmit(data)}
                            renderStatus={renderDone}
                            placeholder="Type a new question (e.g. what is GDPR?)"
                        />
                    </Footer>
                </div>
            </div>
        </div>
    )
}
export default ChatBox